export const Q2_VESTIMENTA = {
  'Uniforme de trabalho (calça e camisa de manga comprida)': 0,
  'Macacão de tecido': 0,
  'Macacão de polipropileno SMS (Spun-Melt-Spun)': 0.5,
  'Macacão de poliolefina': 2,
  'Vestimenta ou macacão forrado (tecido duplo)': 3,
  'Avental longo de manga comprida impermeável ao vapor': 4,
  'Macacão impermeável ao vapor': 10,
  'Macacão impermeável ao vapor sobreposto à roupa de trabalho': 12
}

export const T1_NA = {
  100: 31.7,
  101: 31.6,
  102: 31.5,
  103: 31.5,
  104: 31.4,
  105: 31.4,
  106: 31.3,
  107: 31.2,
  108: 31.2,
  109: 31.1,
  110: 31.1,
  111: 31,
  112: 31,
  113: 30.9,
  114: 30.9,
  115: 30.8,
  116: 30.7,
  117: 30.7,
  118: 30.6,
  119: 30.6,
  120: 30.5,
  121: 30.5,
  122: 30.4,
  123: 30.4,
  124: 30.3,
  125: 30.3,
  126: 30.2,
  127: 30.2,
  128: 30.1,
  129: 30.1,
  130: 30,
  131: 30,
  132: 30,
  133: 29.9,
  134: 29.9,
  135: 29.8,
  136: 29.8,
  137: 29.7,
  138: 29.7,
  139: 29.6,
  140: 29.6,
  141: 29.5,
  142: 29.5,
  143: 29.5,
  144: 29.4,
  145: 29.4,
  146: 29.3,
  147: 29.3,
  148: 29.3,
  149: 29.2,
  150: 29.2,
  151: 29.1,
  152: 29.1,
  153: 29,
  154: 29,
  155: 29,
  156: 28.9,
  157: 28.9,
  158: 28.9,
  159: 28.8,
  160: 28.8,
  161: 28.7,
  162: 28.7,
  163: 28.7,
  164: 28.6,
  165: 28.6,
  166: 28.5,
  167: 28.5,
  168: 28.5,
  169: 28.4,
  170: 28.4,
  171: 28.4,
  172: 28.3,
  173: 28.3,
  174: 28.3,
  175: 28.2,
  176: 28.2,
  177: 28.2,
  178: 28.1,
  179: 28.1,
  180: 28.1,
  181: 28,
  182: 28,
  183: 28,
  184: 27.9,
  185: 27.9,
  186: 27.9,
  187: 27.8,
  188: 27.8,
  189: 27.8,
  190: 27.7,
  191: 27.7,
  192: 27.7,
  193: 27.6,
  194: 27.6,
  195: 27.6,
  196: 27.5,
  197: 27.5,
  198: 27.5,
  199: 27.4,
  200: 27.4,
  201: 27.4,
  202: 27.3,
  203: 27.3,
  204: 27.3,
  205: 27.3,
  206: 27.2,
  207: 27.2,
  208: 27.2,
  209: 27.1,
  210: 27.1,
  211: 27.1,
  212: 27.1,
  213: 27,
  214: 27,
  215: 27,
  216: 26.9,
  217: 26.9,
  218: 26.9,
  219: 26.9,
  220: 26.8,
  221: 26.8,
  222: 26.8,
  223: 26.7,
  224: 26.7,
  225: 26.7,
  226: 26.7,
  227: 26.6,
  228: 26.6,
  229: 26.6,
  230: 26.6,
  231: 26.5,
  232: 26.5,
  233: 26.5,
  234: 26.4,
  235: 26.4,
  236: 26.4,
  237: 26.4,
  238: 26.3,
  239: 26.3,
  240: 26.3,
  241: 26.3,
  242: 26.2,
  243: 26.2,
  244: 26.2,
  245: 26.2,
  246: 26.1,
  247: 26.1,
  248: 26.1,
  249: 26.1,
  250: 26,
  251: 26,
  252: 26,
  253: 26,
  254: 25.9,
  255: 25.9,
  256: 25.9,
  257: 25.9,
  258: 25.8,
  259: 25.8,
  260: 25.8,
  261: 25.8,
  262: 25.8,
  263: 25.7,
  264: 25.7,
  265: 25.7,
  266: 25.7,
  267: 25.6,
  268: 25.6,
  269: 25.6,
  270: 25.6,
  271: 25.5,
  272: 25.5,
  273: 25.5,
  274: 25.5,
  275: 25.5,
  276: 25.4,
  277: 25.4,
  278: 25.4,
  279: 25.4,
  280: 25.3,
  281: 25.3,
  282: 25.3,
  283: 25.3,
  284: 25.3,
  285: 25.2,
  286: 25.2,
  287: 25.2,
  288: 25.2,
  289: 25.2,
  290: 25.1,
  291: 25.1,
  292: 25.1,
  293: 25.1,
  294: 25,
  295: 25,
  296: 25,
  297: 25,
  298: 25,
  299: 24.9,
  300: 24.9,
  301: 24.9,
  302: 24.9,
  303: 24.9,
  304: 24.8,
  305: 24.8,
  306: 24.8,
  307: 24.8,
  308: 24.8,
  309: 24.7,
  310: 24.7,
  311: 24.7,
  312: 24.7,
  313: 24.7,
  314: 24.6,
  315: 24.6,
  316: 24.6,
  317: 24.6,
  318: 24.6,
  319: 24.5,
  320: 24.5,
  321: 24.5,
  322: 24.5,
  323: 24.5,
  324: 24.5,
  325: 24.4,
  326: 24.4,
  327: 24.4,
  328: 24.4,
  329: 24.4,
  330: 24.3,
  331: 24.3,
  332: 24.3,
  333: 24.3,
  334: 24.3,
  335: 24.2,
  336: 24.2,
  337: 24.2,
  338: 24.2,
  339: 24.2,
  340: 24.2,
  341: 24.1,
  342: 24.1,
  343: 24.1,
  344: 24.1,
  345: 24.1,
  346: 24,
  347: 24,
  348: 24,
  349: 24,
  350: 24,
  351: 24,
  352: 23.9,
  353: 23.9,
  354: 23.9,
  355: 23.9,
  356: 23.9,
  357: 23.9,
  358: 23.8,
  359: 23.8,
  360: 23.8,
  361: 23.8,
  362: 23.8,
  363: 23.8,
  364: 23.7,
  365: 23.7,
  366: 23.7,
  367: 23.7,
  368: 23.7,
  369: 23.7,
  370: 23.6,
  371: 23.6,
  372: 23.6,
  373: 23.6,
  374: 23.6,
  375: 23.6,
  376: 23.5,
  377: 23.5,
  378: 23.5,
  379: 23.5,
  380: 23.5,
  381: 23.5,
  382: 23.4,
  383: 23.4,
  384: 23.4,
  385: 23.4,
  386: 23.4,
  387: 23.4,
  388: 23.3,
  389: 23.3,
  390: 23.3,
  391: 23.3,
  392: 23.3,
  393: 23.3,
  394: 23.3,
  395: 23.2,
  396: 23.2,
  397: 23.2,
  398: 23.2,
  399: 23.2,
  400: 23.2,
  401: 23.1,
  402: 23.1,
  403: 23.1,
  404: 23.1,
  405: 23.1,
  406: 23.1,
  407: 23.1,
  408: 23,
  409: 23,
  410: 23,
  411: 23,
  412: 23,
  413: 23,
  414: 23,
  415: 22.9,
  416: 22.9,
  417: 22.9,
  418: 22.9,
  419: 22.9,
  420: 22.9,
  421: 22.8,
  422: 22.8,
  423: 22.8,
  424: 22.8,
  425: 22.8,
  426: 22.8,
  427: 22.8,
  428: 22.7,
  429: 22.7,
  430: 22.7,
  431: 22.7,
  432: 22.7,
  433: 22.7,
  434: 22.7,
  435: 22.6,
  436: 22.6,
  437: 22.6,
  438: 22.6,
  439: 22.6,
  440: 22.6,
  441: 22.6,
  442: 22.6,
  443: 22.5,
  444: 22.5,
  445: 22.5,
  446: 22.5,
  447: 22.5,
  448: 22.5,
  449: 22.5,
  450: 22.4,
  451: 22.4,
  452: 22.4,
  453: 22.4,
  454: 22.4,
  455: 22.4,
  456: 22.4,
  457: 22.3,
  458: 22.3,
  459: 22.3,
  460: 22.3,
  461: 22.3,
  462: 22.3,
  463: 22.3,
  464: 22.3,
  465: 22.1,
  466: 22.1,
  467: 22.1,
  468: 22.1,
  469: 22.1,
  470: 22.1,
  471: 22.1,
  472: 22.1,
  473: 22.1,
  474: 22.1,
  475: 22.1,
  476: 22.1,
  477: 22.1,
  478: 22.1,
  479: 22.1,
  480: 22,
  481: 22,
  482: 22,
  483: 22,
  484: 22,
  485: 22,
  486: 22,
  487: 22,
  488: 21.9,
  489: 21.9,
  490: 21.9,
  491: 21.9,
  492: 21.9,
  493: 21.9,
  494: 21.9,
  495: 21.9,
  496: 21.8,
  497: 21.8,
  498: 21.8,
  499: 21.8,
  500: 21.8,
  501: 21.8,
  502: 21.8,
  503: 21.8,
  504: 21.7,
  505: 21.7,
  506: 21.7,
  507: 21.7,
  508: 21.7,
  509: 21.7,
  510: 21.7,
  511: 21.7,
  512: 21.6,
  513: 21.6,
  514: 21.6,
  515: 21.6,
  516: 21.6,
  517: 21.6,
  518: 21.6,
  519: 21.6,
  520: 21.6,
  521: 21.5,
  522: 21.5,
  523: 21.5,
  524: 21.5,
  525: 21.5,
  526: 21.5,
  527: 21.5,
  528: 21.5,
  529: 21.4,
  530: 21.4,
  531: 21.4,
  532: 21.4,
  533: 21.4,
  534: 21.4,
  535: 21.4,
  536: 21.4,
  537: 21.4,
  538: 21.3,
  539: 21.3,
  540: 21.3,
  541: 21.3,
  542: 21.3,
  543: 21.3,
  544: 21.3,
  545: 21.3,
  546: 21.3,
  547: 21.2,
  548: 21.2,
  549: 21.2,
  550: 21.2,
  551: 21.2,
  552: 21.2,
  553: 21.2,
  554: 21.2,
  555: 21.2,
  556: 21.1,
  557: 21.1,
  558: 21.1,
  559: 21.1,
  560: 21.1,
  561: 21.1,
  562: 21.1,
  563: 21.1,
  564: 21.1,
  565: 21,
  566: 21,
  567: 21,
  568: 21,
  569: 21,
  570: 21,
  571: 21,
  572: 21,
  573: 21,
  574: 20.9,
  575: 20.9,
  576: 20.9,
  577: 20.9,
  578: 20.9,
  579: 20.9,
  580: 20.9,
  581: 20.9,
  582: 20.9,
  583: 20.9,
  584: 20.8,
  585: 20.8,
  586: 20.8,
  587: 20.8,
  588: 20.8,
  589: 20.8,
  590: 20.8,
  591: 20.8,
  592: 20.8,
  593: 20.8,
  594: 20.7,
  595: 20.7,
  596: 20.7,
  597: 20.7,
  598: 20.7,
  599: 20.7,
  600: 20.7,
  601: 20.7,
  602: 20.7
}

export const T2_LEO = {
  100: 33.7,
  101: 33.6,
  102: 33.6,
  103: 33.5,
  104: 33.5,
  105: 33.4,
  106: 33.4,
  107: 33.3,
  108: 33.3,
  109: 33.2,
  110: 33.2,
  111: 33.1,
  112: 33.1,
  113: 33,
  114: 33,
  115: 33,
  116: 32.9,
  117: 32.9,
  118: 32.8,
  119: 32.8,
  120: 32.7,
  121: 32.7,
  122: 32.7,
  123: 32.6,
  124: 32.6,
  125: 32.5,
  126: 32.5,
  127: 32.5,
  128: 32.4,
  129: 32.4,
  130: 32.3,
  131: 32.3,
  132: 32.3,
  133: 32.2,
  134: 32.2,
  135: 32.2,
  136: 32.1,
  137: 32.1,
  138: 32,
  139: 32,
  140: 32,
  141: 31.9,
  142: 31.9,
  143: 31.9,
  144: 31.8,
  145: 31.8,
  146: 31.8,
  147: 31.7,
  148: 31.7,
  149: 31.7,
  150: 31.6,
  151: 31.6,
  152: 31.6,
  153: 31.5,
  154: 31.5,
  155: 31.5,
  156: 31.4,
  157: 31.4,
  158: 31.4,
  159: 31.3,
  160: 31.3,
  161: 31.3,
  162: 31.2,
  163: 31.2,
  164: 31.2,
  165: 31.2,
  166: 31.1,
  167: 31.1,
  168: 31.1,
  169: 31,
  170: 31,
  171: 31,
  172: 30.9,
  173: 30.9,
  174: 30.9,
  175: 30.9,
  176: 30.8,
  177: 30.8,
  178: 30.8,
  179: 30.7,
  180: 30.7,
  181: 30.7,
  182: 30.7,
  183: 30.6,
  184: 30.6,
  185: 30.6,
  186: 30.6,
  187: 30.5,
  188: 30.5,
  189: 30.5,
  190: 30.4,
  191: 30.4,
  192: 30.4,
  193: 30.4,
  194: 30.3,
  195: 30.3,
  196: 30.3,
  197: 30.3,
  198: 30.2,
  199: 30.2,
  200: 30.2,
  201: 30.2,
  202: 30.1,
  203: 30.1,
  204: 30.1,
  205: 30.1,
  206: 30,
  207: 30,
  208: 30,
  209: 30,
  210: 29.9,
  211: 29.9,
  212: 29.9,
  213: 29.9,
  214: 29.9,
  215: 29.8,
  216: 29.8,
  217: 29.8,
  218: 29.8,
  219: 29.7,
  220: 29.7,
  221: 29.7,
  222: 29.7,
  223: 29.6,
  224: 29.6,
  225: 29.6,
  226: 29.6,
  227: 29.6,
  228: 29.5,
  229: 29.5,
  230: 29.5,
  231: 29.5,
  232: 29.4,
  233: 29.4,
  234: 29.4,
  235: 29.4,
  236: 29.4,
  237: 29.3,
  238: 29.3,
  239: 29.3,
  240: 29.3,
  241: 29.3,
  242: 29.2,
  243: 29.2,
  244: 29.2,
  245: 29.2,
  246: 29.2,
  247: 29.1,
  248: 29.1,
  249: 29.1,
  250: 29.1,
  251: 29.1,
  252: 29,
  253: 29,
  254: 29,
  255: 29,
  256: 29,
  257: 28.9,
  258: 28.9,
  259: 28.9,
  260: 28.9,
  261: 28.9,
  262: 28.8,
  263: 28.8,
  264: 28.8,
  265: 28.8,
  266: 28.8,
  267: 28.7,
  268: 28.7,
  269: 28.7,
  270: 28.7,
  271: 28.7,
  272: 28.7,
  273: 28.6,
  274: 28.6,
  275: 28.6,
  276: 28.6,
  277: 28.6,
  278: 28.5,
  279: 28.5,
  280: 28.5,
  281: 28.5,
  282: 28.5,
  283: 28.5,
  284: 28.4,
  285: 28.4,
  286: 28.4,
  287: 28.4,
  288: 28.4,
  289: 28.4,
  290: 28.3,
  291: 28.3,
  292: 28.3,
  293: 28.3,
  294: 28.3,
  295: 28.2,
  296: 28.2,
  297: 28.2,
  298: 28.2,
  299: 28.2,
  300: 28.2,
  301: 28.1,
  302: 28.1,
  303: 28.1,
  304: 28.1,
  305: 28.1,
  306: 28.1,
  307: 28,
  308: 28,
  309: 28,
  310: 28,
  311: 28,
  312: 28,
  313: 28,
  314: 27.9,
  315: 27.9,
  316: 27.9,
  317: 27.9,
  318: 27.9,
  319: 27.9,
  320: 27.8,
  321: 27.8,
  322: 27.8,
  323: 27.8,
  324: 27.8,
  325: 27.8,
  326: 27.7,
  327: 27.7,
  328: 27.7,
  329: 27.7,
  330: 27.7,
  331: 27.7,
  332: 27.7,
  333: 27.6,
  334: 27.6,
  335: 27.6,
  336: 27.6,
  337: 27.6,
  338: 27.6,
  339: 27.6,
  340: 27.5,
  341: 27.5,
  342: 27.5,
  343: 27.5,
  344: 27.5,
  345: 27.5,
  346: 27.5,
  347: 27.4,
  348: 27.4,
  349: 27.4,
  350: 27.4,
  351: 27.4,
  352: 27.4,
  353: 27.4,
  354: 27.3,
  355: 27.3,
  356: 27.3,
  357: 27.3,
  358: 27.3,
  359: 27.3,
  360: 27.3,
  361: 27.2,
  362: 27.2,
  363: 27.2,
  364: 27.2,
  365: 27.2,
  366: 27.2,
  367: 27.2,
  368: 27.1,
  369: 27.1,
  370: 27.1,
  371: 27.1,
  372: 27.1,
  373: 27.1,
  374: 27.1,
  375: 27,
  376: 27,
  377: 27,
  378: 27,
  379: 27,
  380: 27,
  381: 27,
  382: 27,
  383: 26.9,
  384: 26.9,
  385: 26.9,
  386: 26.9,
  387: 26.9,
  388: 26.9,
  389: 26.9,
  390: 26.9,
  391: 26.8,
  392: 26.8,
  393: 26.8,
  394: 26.8,
  395: 26.8,
  396: 26.8,
  397: 26.8,
  398: 26.8,
  399: 26.7,
  400: 26.7,
  401: 26.7,
  402: 26.7,
  403: 26.7,
  404: 26.7,
  405: 26.7,
  406: 26.7,
  407: 26.6,
  408: 26.6,
  409: 26.6,
  410: 26.6,
  411: 26.6,
  412: 26.6,
  413: 26.6,
  414: 26.6,
  415: 26.5,
  416: 26.5,
  417: 26.5,
  418: 26.5,
  419: 26.5,
  420: 26.5,
  421: 26.5,
  422: 26.5,
  423: 26.4,
  424: 26.4,
  425: 26.4,
  426: 26.4,
  427: 26.4,
  428: 26.4,
  429: 26.4,
  430: 26.4,
  431: 26.4,
  432: 26.3,
  433: 26.3,
  434: 26.3,
  435: 26.3,
  436: 26.3,
  437: 26.3,
  438: 26.3,
  439: 26.3,
  440: 26.3,
  441: 26.2,
  442: 26.2,
  443: 26.2,
  444: 26.2,
  445: 26.2,
  446: 26.2,
  447: 26.2,
  448: 26.2,
  449: 26.1,
  450: 26.1,
  451: 26.1,
  452: 26.1,
  453: 26.1,
  454: 26.1,
  455: 26.1,
  456: 26.1,
  457: 26.1,
  458: 26.1,
  459: 26,
  460: 26,
  461: 26,
  462: 26,
  463: 26,
  464: 26,
  465: 26,
  466: 26,
  467: 26,
  468: 25.9,
  469: 25.9,
  470: 25.9,
  471: 25.9,
  472: 25.9,
  473: 25.9,
  474: 25.9,
  475: 25.9,
  476: 25.9,
  477: 25.8,
  478: 25.8,
  479: 25.8,
  480: 25.8,
  481: 25.8,
  482: 25.8,
  483: 25.8,
  484: 25.8,
  485: 25.8,
  486: 25.8,
  487: 25.7,
  488: 25.7,
  489: 25.7,
  490: 25.7,
  491: 25.7,
  492: 25.7,
  493: 25.7,
  494: 25.7,
  495: 25.7,
  496: 25.7,
  497: 25.6,
  498: 25.6,
  499: 25.6,
  500: 25.6,
  501: 25.6,
  502: 25.6,
  503: 25.6,
  504: 25.6,
  505: 25.6,
  506: 25.6,
  507: 25.5,
  508: 25.5,
  509: 25.5,
  510: 25.5,
  511: 25.5,
  512: 25.5,
  513: 25.5,
  514: 25.5,
  515: 25.5,
  516: 25.5,
  517: 25.4,
  518: 25.4,
  519: 25.4,
  520: 25.4,
  521: 25.4,
  522: 25.4,
  523: 25.4,
  524: 25.4,
  525: 25.4,
  526: 25.4,
  527: 25.3,
  528: 25.3,
  529: 25.3,
  530: 25.3,
  531: 25.3,
  532: 25.3,
  533: 25.3,
  534: 25.3,
  535: 25.3,
  536: 25.3,
  537: 25.3,
  538: 25.2,
  539: 25.2,
  540: 25.2,
  541: 25.2,
  542: 25.2,
  543: 25.2,
  544: 25.2,
  545: 25.2,
  546: 25.2,
  547: 25.2,
  548: 25.2,
  549: 25.1,
  550: 25.1,
  551: 25.1,
  552: 25.1,
  553: 25.1,
  554: 25.1,
  555: 25.1,
  556: 25.1,
  557: 25.1,
  558: 25.1,
  559: 25.1,
  560: 25,
  561: 25,
  562: 25,
  563: 25,
  564: 25,
  565: 25,
  566: 25,
  567: 25,
  568: 25,
  569: 25,
  570: 25,
  571: 24.9,
  572: 24.9,
  573: 24.9,
  574: 24.9,
  575: 24.9,
  576: 24.9,
  577: 24.9,
  578: 24.9,
  579: 24.9,
  580: 24.9,
  581: 24.9,
  582: 24.9,
  583: 24.8,
  584: 24.8,
  585: 24.8,
  586: 24.8,
  587: 24.8,
  588: 24.8,
  589: 24.8,
  590: 24.8,
  591: 24.8,
  592: 24.8,
  593: 24.8,
  594: 24.8,
  595: 24.7,
  596: 24.7,
  597: 24.7,
  598: 24.7,
  599: 24.7,
  600: 24.7,
  601: 24.7,
  602: 24.7,
  603: 24.7,
  604: 24.7,
  605: 24.7,
  606: 24.7
}

export const T4_RI = {
  100.0: [32.3, 33.7],
  101.0: [32.2, 33.6],
  102.0: [32.2, 33.6],
  103.0: [32.1, 33.5],
  104.0: [32.1, 33.5],
  105.0: [32.0, 33.4],
  106.0: [32.0, 33.4],
  107.0: [31.9, 33.3],
  108.0: [31.9, 33.3],
  109.0: [31.8, 33.2],
  110.0: [31.8, 33.2],
  111.0: [31.7, 33.1],
  112.0: [31.7, 33.1],
  113.0: [31.6, 33.0],
  114.0: [31.6, 33.0],
  115.0: [31.6, 33.0],
  116.0: [31.5, 32.9],
  117.0: [31.5, 32.9],
  118.0: [31.4, 32.8],
  119.0: [31.4, 32.8],
  120.0: [31.3, 32.7],
  121.0: [31.3, 32.7],
  122.0: [31.3, 32.7],
  123.0: [31.2, 32.6],
  124.0: [31.2, 32.6],
  125.0: [31.1, 32.5],
  126.0: [31.1, 32.5],
  127.0: [31.1, 32.5],
  128.0: [31.0, 32.4],
  129.0: [31.0, 32.4],
  130.0: [30.9, 32.3],
  131.0: [30.9, 32.3],
  132.0: [30.9, 32.3],
  133.0: [30.8, 32.2],
  134.0: [30.8, 32.2],
  135.0: [30.8, 32.2],
  136.0: [30.7, 32.1],
  137.0: [30.7, 32.1],
  138.0: [30.6, 32.0],
  139.0: [30.6, 32.0],
  140.0: [30.6, 32.0],
  141.0: [30.5, 31.9],
  142.0: [30.5, 31.9],
  143.0: [30.5, 31.9],
  144.0: [30.4, 31.8],
  145.0: [30.4, 31.8],
  146.0: [30.4, 31.8],
  147.0: [30.3, 31.7],
  148.0: [30.3, 31.7],
  149.0: [30.3, 31.7],
  150.0: [30.2, 31.6],
  151.0: [30.2, 31.6],
  152.0: [30.2, 31.6],
  153.0: [30.1, 31.5],
  154.0: [30.1, 31.5],
  155.0: [30.1, 31.5],
  156.0: [30.0, 31.4],
  157.0: [30.0, 31.4],
  158.0: [30.0, 31.4],
  159.0: [29.9, 31.3],
  160.0: [29.9, 31.3],
  161.0: [29.9, 31.3],
  162.0: [29.8, 31.2],
  163.0: [29.8, 31.2],
  164.0: [29.8, 31.2],
  165.0: [29.7, 31.1],
  166.0: [29.7, 31.1],
  167.0: [29.7, 31.1],
  168.0: [29.7, 31.1],
  169.0: [29.6, 31.0],
  170.0: [29.6, 31.0],
  171.0: [29.6, 31.0],
  172.0: [29.5, 30.9],
  173.0: [29.5, 30.9],
  174.0: [29.5, 30.9],
  175.0: [29.5, 30.9],
  176.0: [29.4, 30.8],
  177.0: [29.4, 30.8],
  178.0: [29.4, 30.8],
  179.0: [29.3, 30.7],
  180.0: [29.3, 30.7],
  181.0: [29.3, 30.7],
  182.0: [29.3, 30.7],
  183.0: [29.2, 30.6],
  184.0: [29.2, 30.6],
  185.0: [29.2, 30.6],
  186.0: [29.2, 30.6],
  187.0: [29.1, 30.5],
  188.0: [29.1, 30.5],
  189.0: [29.1, 30.5],
  190.0: [29.0, 30.4],
  191.0: [29.0, 30.4],
  192.0: [29.0, 30.4],
  193.0: [29.0, 30.4],
  194.0: [28.9, 30.3],
  195.0: [28.9, 30.3],
  196.0: [28.9, 30.3],
  197.0: [28.9, 30.3],
  198.0: [28.8, 30.2],
  199.0: [28.8, 30.2],
  200.0: [28.8, 30.2],
  201.0: [28.8, 30.2],
  202.0: [28.7, 30.1],
  203.0: [28.7, 30.1],
  204.0: [28.7, 30.1],
  205.0: [28.7, 30.1],
  206.0: [28.6, 30.0],
  207.0: [28.6, 30.0],
  208.0: [28.6, 30.0],
  209.0: [28.6, 30.0],
  210.0: [28.5, 29.9],
  211.0: [28.5, 29.9],
  212.0: [28.5, 29.9],
  213.0: [28.5, 29.9],
  214.0: [28.5, 29.9],
  215.0: [28.4, 29.8],
  216.0: [28.4, 29.8],
  217.0: [28.4, 29.8],
  218.0: [28.4, 29.8],
  219.0: [28.3, 29.7],
  220.0: [28.3, 29.7],
  221.0: [28.3, 29.7],
  222.0: [28.3, 29.7],
  223.0: [28.2, 29.6],
  224.0: [28.2, 29.6],
  225.0: [28.2, 29.6],
  226.0: [28.2, 29.6],
  227.0: [28.2, 29.6],
  228.0: [28.1, 29.5],
  229.0: [28.1, 29.5],
  230.0: [28.1, 29.5],
  231.0: [28.1, 29.5],
  232.0: [28.0, 29.4],
  233.0: [28.0, 29.4],
  234.0: [28.0, 29.4],
  235.0: [28.0, 29.4],
  236.0: [28.0, 29.4],
  237.0: [27.9, 29.3],
  238.0: [27.9, 29.3],
  239.0: [27.9, 29.3],
  240.0: [27.9, 29.3],
  241.0: [27.9, 29.3],
  242.0: [27.8, 29.2],
  243.0: [27.8, 29.2],
  244.0: [27.8, 29.2],
  245.0: [27.8, 29.2],
  246.0: [27.8, 29.2],
  247.0: [27.7, 29.1],
  248.0: [27.7, 29.1],
  249.0: [27.7, 29.1],
  250.0: [27.7, 29.1],
  251.0: [27.7, 29.1],
  252.0: [27.6, 29.0],
  253.0: [27.6, 29.0],
  254.0: [27.6, 29.0],
  255.0: [27.6, 29.0],
  256.0: [27.6, 29.0],
  257.0: [27.5, 28.9],
  258.0: [27.5, 28.9],
  259.0: [27.5, 28.9],
  260.0: [27.5, 28.9],
  261.0: [27.5, 28.9],
  262.0: [27.4, 28.8],
  263.0: [27.4, 28.8],
  264.0: [27.4, 28.8],
  265.0: [27.4, 28.8],
  266.0: [27.4, 28.8],
  267.0: [27.3, 28.7],
  268.0: [27.3, 28.7],
  269.0: [27.3, 28.7],
  270.0: [27.3, 28.7],
  271.0: [27.3, 28.7],
  272.0: [27.3, 28.7],
  273.0: [27.2, 28.6],
  274.0: [27.2, 28.6],
  275.0: [27.2, 28.6],
  276.0: [27.2, 28.6],
  277.0: [27.2, 28.6],
  278.0: [27.1, 28.5],
  279.0: [27.1, 28.5],
  280.0: [27.1, 28.5],
  281.0: [27.1, 28.5],
  282.0: [27.1, 28.5],
  283.0: [27.1, 28.5],
  284.0: [27.0, 28.4],
  285.0: [27.0, 28.4],
  286.0: [27.0, 28.4],
  287.0: [27.0, 28.4],
  288.0: [27.0, 28.4],
  289.0: [26.9, 28.3],
  290.0: [26.9, 28.3],
  291.0: [26.9, 28.3],
  292.0: [26.9, 28.3],
  293.0: [26.9, 28.3],
  294.0: [26.9, 28.3],
  295.0: [26.8, 28.2],
  296.0: [26.8, 28.2],
  297.0: [26.8, 28.2],
  298.0: [26.8, 28.2],
  299.0: [26.8, 28.2],
  300.0: [26.8, 28.2],
  301.0: [26.7, 28.1],
  302.0: [26.7, 28.1],
  303.0: [26.7, 28.1],
  304.0: [26.7, 28.1],
  305.0: [26.7, 28.1],
  306.0: [26.7, 28.1],
  307.0: [26.6, 28.0],
  308.0: [26.6, 28.0],
  309.0: [26.6, 28.0],
  310.0: [26.6, 28.0],
  311.0: [26.6, 28.0],
  312.0: [26.6, 28.0],
  313.0: [26.6, 28.0],
  314.0: [26.5, 27.9],
  315.0: [26.5, 27.9],
  316.0: [26.5, 27.9],
  317.0: [26.5, 27.9],
  318.0: [26.5, 27.9],
  319.0: [26.5, 27.9],
  320.0: [26.4, 27.8],
  321.0: [26.4, 27.8],
  322.0: [26.4, 27.8],
  323.0: [26.4, 27.8],
  324.0: [26.4, 27.8],
  325.0: [26.4, 27.8],
  326.0: [26.3, 27.7],
  327.0: [26.3, 27.7],
  328.0: [26.3, 27.7],
  329.0: [26.3, 27.7],
  330.0: [26.3, 27.7],
  331.0: [26.3, 27.7],
  332.0: [26.3, 27.7],
  333.0: [26.2, 27.6],
  334.0: [26.2, 27.6],
  335.0: [26.2, 27.6],
  336.0: [26.2, 27.6],
  337.0: [26.2, 27.6],
  338.0: [26.2, 27.6],
  339.0: [26.2, 27.6],
  340.0: [26.1, 27.5],
  341.0: [26.1, 27.5],
  342.0: [26.1, 27.5],
  343.0: [26.1, 27.5],
  344.0: [26.1, 27.5],
  345.0: [26.1, 27.5],
  346.0: [26.1, 27.5],
  347.0: [26.0, 27.4],
  348.0: [26.0, 27.4],
  349.0: [26.0, 27.4],
  350.0: [26.0, 27.4],
  351.0: [26.0, 27.4],
  352.0: [26.0, 27.4],
  353.0: [26.0, 27.4],
  354.0: [25.9, 27.3],
  355.0: [25.9, 27.3],
  356.0: [25.9, 27.3],
  357.0: [25.9, 27.3],
  358.0: [25.9, 27.3],
  359.0: [25.9, 27.3],
  360.0: [25.9, 27.3],
  361.0: [25.8, 27.2],
  362.0: [25.8, 27.2],
  363.0: [25.8, 27.2],
  364.0: [25.8, 27.2],
  365.0: [25.8, 27.2],
  366.0: [25.8, 27.2],
  367.0: [25.8, 27.2],
  368.0: [25.7, 27.1],
  369.0: [25.7, 27.1],
  370.0: [25.7, 27.1],
  371.0: [25.7, 27.1],
  372.0: [25.7, 27.1],
  373.0: [25.7, 27.1],
  374.0: [25.7, 27.1],
  375.0: [25.6, 27.0],
  376.0: [25.6, 27.0],
  377.0: [25.6, 27.0],
  378.0: [25.6, 27.0],
  379.0: [25.6, 27.0],
  380.0: [25.6, 27.0],
  381.0: [25.6, 27.0],
  382.0: [25.6, 27.0],
  383.0: [25.5, 26.9],
  384.0: [25.5, 26.9],
  385.0: [25.5, 26.9],
  386.0: [25.5, 26.9],
  387.0: [25.5, 26.9],
  388.0: [25.5, 26.9],
  389.0: [25.5, 26.9],
  390.0: [25.5, 26.9],
  391.0: [25.4, 26.8],
  392.0: [25.4, 26.8],
  393.0: [25.4, 26.8],
  394.0: [25.4, 26.8],
  395.0: [25.4, 26.8],
  396.0: [25.4, 26.8],
  397.0: [25.4, 26.8],
  398.0: [25.4, 26.8],
  399.0: [25.3, 26.7],
  400.0: [25.3, 26.7],
  401.0: [25.3, 26.7],
  402.0: [25.3, 26.7],
  403.0: [25.3, 26.7],
  404.0: [25.3, 26.7],
  405.0: [25.3, 26.7],
  406.0: [25.3, 26.7],
  407.0: [25.2, 26.6],
  408.0: [25.2, 26.6],
  409.0: [25.2, 26.6],
  410.0: [25.2, 26.6],
  411.0: [25.2, 26.6],
  412.0: [25.2, 26.6],
  413.0: [25.2, 26.6],
  414.0: [25.2, 26.6],
  415.0: [25.1, 26.5],
  416.0: [25.1, 26.5],
  417.0: [25.1, 26.5],
  418.0: [25.1, 26.5],
  419.0: [25.1, 26.5],
  420.0: [25.1, 26.5],
  421.0: [25.1, 26.5],
  422.0: [25.1, 26.5],
  423.0: [25.0, 26.4],
  424.0: [25.0, 26.4],
  425.0: [25.0, 26.4],
  426.0: [25.0, 26.4],
  427.0: [25.0, 26.4],
  428.0: [25.0, 26.4],
  429.0: [25.0, 26.4],
  430.0: [25.0, 26.4],
  431.0: [25.0, 26.4],
  432.0: [24.9, 26.3],
  433.0: [24.9, 26.3],
  434.0: [24.9, 26.3],
  435.0: [24.9, 26.3],
  436.0: [24.9, 26.3],
  437.0: [24.9, 26.3],
  438.0: [24.9, 26.3],
  439.0: [24.9, 26.3],
  440.0: [24.9, 26.3],
  441.0: [24.8, 26.2],
  442.0: [24.8, 26.2],
  443.0: [24.8, 26.2],
  444.0: [24.8, 26.2],
  445.0: [24.8, 26.2],
  446.0: [24.8, 26.2],
  447.0: [24.8, 26.2],
  448.0: [24.8, 26.2],
  449.0: [24.7, 26.1],
  450.0: [24.7, 26.1],
  451.0: [24.7, 26.1],
  452.0: [24.7, 26.1],
  453.0: [24.7, 26.1],
  454.0: [24.7, 26.1],
  455.0: [24.7, 26.1],
  456.0: [24.7, 26.1],
  457.0: [24.7, 26.1],
  458.0: [24.7, 26.1],
  459.0: [24.6, 26.0],
  460.0: [24.6, 26.0],
  461.0: [24.6, 26.0],
  462.0: [24.6, 26.0],
  463.0: [24.6, 26.0],
  464.0: [24.6, 26.0],
  465.0: [24.6, 26.0],
  466.0: [24.6, 26.0],
  467.0: [24.6, 26.0],
  468.0: [24.5, 25.9],
  469.0: [24.5, 25.9],
  470.0: [24.5, 25.9],
  471.0: [24.5, 25.9],
  472.0: [24.5, 25.9],
  473.0: [24.5, 25.9],
  474.0: [24.5, 25.9],
  475.0: [24.5, 25.9],
  476.0: [24.5, 25.9],
  477.0: [24.4, 25.8],
  478.0: [24.4, 25.8],
  479.0: [24.4, 25.8],
  480.0: [24.4, 25.8],
  481.0: [24.4, 25.8],
  482.0: [24.4, 25.8],
  483.0: [24.4, 25.8],
  484.0: [24.4, 25.8],
  485.0: [24.4, 25.8],
  486.0: [24.4, 25.8],
  487.0: [24.3, 25.7],
  488.0: [24.3, 25.7],
  489.0: [24.3, 25.7],
  490.0: [24.3, 25.7],
  491.0: [24.3, 25.7],
  492.0: [24.3, 25.7],
  493.0: [24.3, 25.7],
  494.0: [24.3, 25.7],
  495.0: [24.3, 25.7],
  496.0: [24.3, 25.7],
  497.0: [24.2, 25.6],
  498.0: [24.2, 25.6],
  499.0: [24.2, 25.6],
  500.0: [24.2, 25.6],
  501.0: [24.2, 25.6],
  502.0: [24.2, 25.6],
  503.0: [24.2, 25.6],
  504.0: [24.2, 25.6],
  505.0: [24.2, 25.6],
  506.0: [24.2, 25.6],
  507.0: [24.1, 25.5],
  508.0: [24.1, 25.5],
  509.0: [24.1, 25.5],
  510.0: [24.1, 25.5],
  511.0: [24.1, 25.5],
  512.0: [24.1, 25.5],
  513.0: [24.1, 25.5],
  514.0: [24.1, 25.5],
  515.0: [24.1, 25.5],
  516.0: [24.1, 25.5],
  517.0: [24.0, 25.4],
  518.0: [24.0, 25.4],
  519.0: [24.0, 25.4],
  520.0: [24.0, 25.4],
  521.0: [24.0, 25.4],
  522.0: [24.0, 25.4],
  523.0: [24.0, 25.4],
  524.0: [24.0, 25.4],
  525.0: [24.0, 25.4],
  526.0: [24.0, 25.4],
  527.0: [23.9, 25.3],
  528.0: [23.9, 25.3],
  529.0: [23.9, 25.3],
  530.0: [23.9, 25.3],
  531.0: [23.9, 25.3],
  532.0: [23.9, 25.3],
  533.0: [23.9, 25.3],
  534.0: [23.9, 25.3],
  535.0: [23.9, 25.3],
  536.0: [23.9, 25.3],
  537.0: [23.9, 25.3],
  538.0: [23.8, 25.2],
  539.0: [23.8, 25.2],
  540.0: [23.8, 25.2],
  541.0: [23.8, 25.2],
  542.0: [23.8, 25.2],
  543.0: [23.8, 25.2],
  544.0: [23.8, 25.2],
  545.0: [23.8, 25.2],
  546.0: [23.8, 25.2],
  547.0: [23.8, 25.2],
  548.0: [23.8, 25.2],
  549.0: [23.7, 25.1],
  550.0: [23.7, 25.1],
  551.0: [23.7, 25.1],
  552.0: [23.7, 25.1],
  553.0: [23.7, 25.1],
  554.0: [23.7, 25.1],
  555.0: [23.7, 25.1],
  556.0: [23.7, 25.1],
  557.0: [23.7, 25.1],
  558.0: [23.7, 25.1],
  559.0: [23.7, 25.1],
  560.0: [23.6, 25.0],
  561.0: [23.6, 25.0],
  562.0: [23.6, 25.0],
  563.0: [23.6, 25.0],
  564.0: [23.6, 25.0],
  565.0: [23.6, 25.0],
  566.0: [23.6, 25.0],
  567.0: [23.6, 25.0],
  568.0: [23.6, 25.0],
  569.0: [23.6, 25.0],
  570.0: [23.6, 25.0],
  571.0: [23.5, 24.9],
  572.0: [23.5, 24.9],
  573.0: [23.5, 24.9],
  574.0: [23.5, 24.9],
  575.0: [23.5, 24.9],
  576.0: [23.5, 24.9],
  577.0: [23.5, 24.9],
  578.0: [23.5, 24.9],
  579.0: [23.5, 24.9],
  580.0: [23.5, 24.9],
  581.0: [23.5, 24.9],
  582.0: [23.5, 24.9],
  583.0: [23.4, 24.8],
  584.0: [23.4, 24.8],
  585.0: [23.4, 24.8],
  586.0: [23.4, 24.8],
  587.0: [23.4, 24.8],
  588.0: [23.4, 24.8],
  589.0: [23.4, 24.8],
  590.0: [23.4, 24.8],
  591.0: [23.4, 24.8],
  592.0: [23.4, 24.8],
  593.0: [23.4, 24.8],
  594.0: [23.4, 24.8],
  595.0: [23.3, 24.7],
  596.0: [23.3, 24.7],
  597.0: [23.3, 24.7],
  598.0: [23.3, 24.7],
  599.0: [23.3, 24.7],
  600.0: [23.3, 24.7],
  601.0: [23.3, 24.7],
  602.0: [23.3, 24.7],
  603.0: [23.3, 24.7],
  604.0: [23.3, 24.7],
  605.0: [23.3, 24.7],
  606.0: [23.3, 24.7]
}
